import { Amplify, ResourcesConfig } from "aws-amplify";
import { Authenticator, Text } from "@aws-amplify/ui-react";
import {
  ENVIRONMENT_LABEL,
  LANDING_PAGE_URL,
  USER_POOL_CLIENT_ID,
  USER_POOL_ID,
} from "./environment";
import { I18nextProvider, useTranslation } from "react-i18next";
import { NavLink, Outlet, Route, Routes } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import Logo from "./components/Images/Icon.svg";
import Logout from "./components/Logout";
import React from "react";
import axios from "axios";
import { defaultNS } from "./setup/i18n-namespace";
import { fetchAuthSession } from "@aws-amplify/auth";
import i18n from "./setup/i18n";
import logo from "./logo.min.svg";
import "@aws-amplify/ui-react/styles.css";
import "./index.scss";

/**
 * The application.
 *
 * @class
 */
function App()
{
  console.info(`Starting MuMiver.se Login v${__APP_VERSION__}`);

  const darkMode
    = window.matchMedia
    && window.matchMedia("(prefers-color-scheme: dark)").matches;

  const body = document.getElementsByTagName("body")[0];

  if (body !== null && darkMode && !body.classList.contains("dark-mode"))
  {
    body.classList.add("dark-mode");
  }
  const components = {
    Header()
    {
      return (
        <div className="mb-12 font-medium text-lg">
          <img src={Logo} alt="logo" className="w-[220px] " />
          <div className="text-white my-8">
            {" "}
            Sign in to your account or Register as a new user !
          </div>
        </div>
      );
    },

    Footer()
    {
      return (
        <div className="py-6">
          <Text className="text-white/60">
            © All Rights Reserved - Mensch und Maschine - 2024
          </Text>
        </div>
      );
    },
  };

  const amplifyConfig: ResourcesConfig = {
    Auth: {
      Cognito: {
        userPoolId: USER_POOL_ID,
        userPoolClientId: USER_POOL_CLIENT_ID,
      },
    },
  };

  Amplify.configure(amplifyConfig);

  const { t } = useTranslation(defaultNS);

  const formFields = {
    signUp: {},
  };

  return (
    <div className="bg-[url('./components/Images/background-image.svg')] bg-cover bg-no-repeat h-screen">
      <div className="bg-[url('./components/Images/Blueprint.svg')] bg-cover bg-no-repeat h-screen ">
        <div className="bg-slate-900/30 flex-col h-screen w-3/6 content-center justify-center">
          <I18nextProvider i18n={i18n} defaultNS={defaultNS}>
            <Authenticator
              signUpAttributes={["email", "given_name", "family_name"]}
              loginMechanisms={["email"]}
              formFields={formFields}
              components={components}
            >
              {({ signOut }) => 
              {
                try 
                {
                  if (window.sessionStorage)
                  {
                    fetchAuthSession().then((session) => 
                    {
                      const token
                        = session.tokens?.idToken?.payload.toString() ?? "";

                      window.sessionStorage.setItem("userToken", token);

                      const urlQueryParameters = new URLSearchParams(
                        window.location.search,
                      );

                      const redirectUrl = urlQueryParameters.get("redirectUrl");

                      if (
                        redirectUrl
                        && !window.location.pathname.includes("logout")
                      )
                      {
                        window.location.href = `${redirectUrl}${
                          !redirectUrl.includes("?") ? "?" : "&"
                        }accessToken=${encodeURIComponent(session.tokens?.accessToken?.toString() ?? "")}&idToken=${encodeURIComponent(session.tokens?.idToken?.toString() ?? "")}&refreshToken=${""}`;
                      }
                      else if (
                        !redirectUrl
                        && !window.location.pathname.includes("logout")
                      )
                      {
                        window.location.href = LANDING_PAGE_URL;
                      }

                      return (
                        <div>
                          <header>
                            <img src={logo} alt="logo" />
                            {ENVIRONMENT_LABEL
                              && ENVIRONMENT_LABEL.toUpperCase()
                                !== "PRODUCTION" && (
                              <span>{ENVIRONMENT_LABEL}</span>
                            )}
                          </header>
                          <NavLink to={"logout"}>Logout</NavLink>
                          <ErrorBoundary>
                            <Routes>
                              <Route
                                path="logout"
                                element={<Logout prop={t} signOut={signOut} />}
                              />
                            </Routes>
                            <Outlet />
                          </ErrorBoundary>
                        </div>
                      );
                    });
                  }
                }
                catch (error: unknown)
                {
                  console.error(error);

                  axios
                    .post(
                      "/common/v1/log?logLevel=error",
                      JSON.stringify(
                        `error while authenticating\r\n${JSON.stringify(
                          error,
                        )}`,
                      ),
                      {
                        headers: {
                          "Content-Type": "application/json",
                        },
                      },
                    )
                    .then((response) => 
                    {
                      console.debug("[App] Login error logged", {
                        response: response,
                      });
                    });

                  return <></>;
                }

                return <></>;
              }}
            </Authenticator>
          </I18nextProvider>
        </div>
      </div>
    </div>
  );
}

export default App;